/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css, keyframes } from '@emotion/react';
import React, { useEffect, useState } from 'react';
import { IconButton } from '@fluentui/react';

const fadeIn = keyframes`
  from { bottom: -50px; }
  to { bottom: 0; }
`;

const fadeOut = keyframes`
  from { bottom: 0; }
  to { bottom: -50px; }
`;

const snackbarStyles = css`
  min-width: 300px;
  background-color: #000;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  color: #fff;
  position: fixed;
  z-index: 999999999999;
  left: 50%;
  bottom: -50px;
  height: 50px;
  transform: translate(-50%, 0);
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  padding: 0px 10px 0px 30px;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, .20), 
              0px 6px 10px 0px rgba(0, 0, 0, .14), 
              0px 1px 18px 0px rgba(0, 0, 0, .12);
  transition: bottom 0.3s ease-in-out;

  &.show {
    bottom: 0;
    animation: ${fadeIn} 0.3s;
  }

  &.hide {
    animation: ${fadeOut} 0.3s;
  }
`;

const Toast = ({ show, message, onClose }) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (show) {
      setIsActive(true);
      const timer = setTimeout(() => {
        setIsActive(false);
        if (onClose) onClose();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  return (
    <div css={snackbarStyles} className={isActive ? 'show' : 'hide'}>
      {message}
      <IconButton 
        styles={{ icon: { color: '#fff !important' }, rootHovered: { backgroundColor:'#ffffff42'} }} 
        onClick={() => setIsActive(false)}
        iconProps={{ iconName: 'Cancel' }} 
      />
    </div>
  );
};

export default Toast;
